<script setup>
import CustomButton from "@/components/Button/Button.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const toggleValue = ref(false);
const uploaded = ref([
    {
        id: 1,
        name: 'file1',
        type: 'jpg',
        size: '2MB',
        status: 'uploaded'
    },
    {
        id: 2,
        name: 'file2',
        type: 'png',
        size: '2MB',
        status: 'failed'
    },
    {
        id: 3,
        name: 'file3',
        type: 'pdf',
        size: '2MB',
        status: 'progress'
    },
]);

const { t } = useI18n(); // Use the i18n instance
</script>

<template>
    <div class="w-1/2 flex flex-col gap-8 py-12 mainContainer">
        <div class="flex flex-col gap-2">
            <span class=" responsive-body-medium semiboldText">{{ t('profile.profilePicture') }}</span>
            <div class="flex align-center gap-5">
                <div class="p-12 imageProfile">
                    <img src="@/assets/icons/svg/Guest_40x40.svg" alt="Profile Picture" />
                </div>
                <div class="flex flex-col">
                    <CustomButton type="outline-black" size="outlinesmall" class=" responsive-body-small w-fit h-7"
                        :rounded="true" @click="onBook">{{ t('profile.uploadPhoto') }}
                    </CustomButton>
                    <span class=" responsive-body-small semiboldText">{{ t('profile.fileRequirements') }}</span>
                </div>
            </div>
        </div>
        <div class="bg-notifications-completed px-5 py-2.5 rounded-8xl align-center font-semibold text-xs">
            {{ t('profile.infoNote') }}
        </div>
        <div>
            <div class="flex gap-4 rowClass">
                <VTextField :label="t('profile.firstName')" type="name" variant="underlined"></VTextField>
                <VTextField :label="t('profile.lastName')" type="surname" variant="underlined"></VTextField>
            </div>
            <div class="flex gap-4 rowClass">
                <VTextField :label="t('profile.nationality')" type="nationality" variant="underlined"></VTextField>
                <VTextField :label="t('profile.birthdate')" type="birthdate" variant="underlined"></VTextField>
            </div>
            <div class="flex gap-4">
                <VTextField :label="t('profile.passportNumber')" type="pass_number" variant="underlined"></VTextField>
                <VTextField :label="t('profile.passportExpiryDate')" type="pass_date" variant="underlined"></VTextField>
            </div>
            <div>
                <span>{{ t('profile.passportPhoto') }}</span>
                <div
                    class="bg-background-light flex justify-between align-center py-3.5 px-5 rounded-8xl photoPass">
                    <div>
                        <div class=" responsive-body-small rmMobile">{{ t('profile.uploadInstructions') }}</div>
                        <span class=" responsive-body-small semiboldText">{{ t('profile.fileRequirements') }}</span>
                    </div>
                    <CustomButton type="outline-black" size="outlinesmall" class=" w-fit h-7"
                        :rounded="true" @click="onBook">{{ t('profile.uploadFiles') }}
                    </CustomButton>
                </div>
            </div>
            <div class="flex gap-4 rowClass">
                <VTextField :label="t('profile.email')" type="email" variant="underlined"></VTextField>
                <VTextField :label="t('profile.phoneNumber')" type="phone" variant="underlined"></VTextField>
            </div>
            <div>
                <div class=" responsive-body-medium align-center flex gap-3">
                    {{ t('profile.sailingLicense') }}
                    <toggle-switch v-model="toggleValue" />
                </div>
                <div class="customBoxClass">
                    <div
                        class="bg-background-light flex justify-between align-center py-3.5 px-5 rounded-8xl licensesClass">
                        <div>
                            <div class="text-sm">{{ t('profile.uploadLicenseFiles') }}</div>
                            <span class=" responsive-body-small semiboldText">{{ t('profile.fileRequirements') }}</span>
                        </div>
                        <CustomButton type="outline-black" size="outlinesmall" class=" w-fit h-7"
                            :rounded="true" @click="onBook">{{ t('profile.uploadFiles') }}
                        </CustomButton>
                    </div>
                    <div v-if="uploaded.length > 0">
                        <div v-for="file in uploaded" :key="file.id"
                            class="flex justify-between align-center py-3.5 px-5 customBorder">
                            <div class="flex gap-3">
                                <span class=" responsive-body-small ">{{ file.name }}</span>
                                <span class="responsive-body-xsmall semiboldText">{{ file.size }}</span>
                            </div>
                            <div class="flex gap-3">
                                <div v-if="file.status == 'uploaded'">
                                    <img src="@/assets/icons/svg/Check cycle_16x16.svg" alt="Uploaded" />
                                </div>
                                <div v-else-if="file.status == 'failed'">
                                    <img src="@/assets/icons/svg/exclamation.svg" alt="Failed" />
                                </div>
                                <div v-else-if="file.status == 'progress'">
                                    <div class="responsive-body-xsmall semiboldText">75%</div>
                                </div>
                                <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CustomButton type="black" class="w-fit px-5" :rounded="true">{{ t('profile.save') }}</CustomButton>
    </div>
</template>

<style scoped>
.semiboldText {
    color: #8C8B94;
}

.imageProfile {
    border: 1px solid #B7B6BE;
    width: fit-content;
    border-radius: 100%
}

.customBoxClass {
    border: 1px solid #EEEEF0;
    border-radius: 10px;
}

.customBorder {
    border-bottom: 1px solid #EEEEF0;
}

.progress {
    border-bottom: 1px solid #9BE7BA;
}

@media (max-width:768px) {
    .mainContainer {
        width: 100%;
        padding: 37px 20px;
    }

    .rowClass {
        flex-direction: column;
        gap: 0px;
    }

    .rmMobile {
        display: none;
    }

    .photoPass {
        flex-direction: row-reverse;
    }

    .licensesClass {
        flex-direction: column;
        gap: 10px;
    }

    .licensesClass>div,
    .licensesClass>button {
        align-self: start;
    }
}
</style>
